<template>
    <!-- 时间范围选择器 -->
    <el-date-picker
        popper-class='date_range_picker'
        :style="'width:'+width+'px'" 
        v-model="dateVal"
        type="datetimerange"
        :size="size"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
        :picker-options="pickerOptions"
        @change="changeDate">
      </el-date-picker>
</template>

<script>

export default {
  model: {
    prop: "date",
  },
  props: {
    date: Array,
    showShortcuts: {
      // 是否显示快捷选项
      type: Boolean,
      default: true,
    },
    disabledRange: {
      // 可选的时间范围
      type: Array,
      default() {
        return [];
      },
    },
    size: {
      type: String,
      default: "small",
    },
    width: {
      type: Number,
      default: 320,
    },
  },
  data() {
    return {
      dateVal: this.date
    }
  },
  watch: {
    dateVal(val) {
      this.$emit("input", val);
    },
    date(val) {
      this.dateVal = val;
    },
  },
  computed: {
    pickerOptions() {
      let _self = this;
      let pickerOption = {
        // 可选的时间范围
        disabledDate(time) {
          let isDisabled = false;
          if (_self.disabledRange.length) {
            let starDate = "";
            let endDate = "";
            let itemTime = time.getTime();
            if (_self.disabledRange[0])
              starDate = _self.$moment(_self.disabledRange[0]).valueOf();
            if (_self.disabledRange[1])
              endDate = _self.$moment(_self.disabledRange[1]).valueOf();
            if (_self.disabledRange[0] && !_self.disabledRange[1]) {
              isDisabled = itemTime < starDate;
            }
            if (!_self.disabledRange[0] && _self.disabledRange[1]) {
              isDisabled = itemTime > endDate;
            }
            if (_self.disabledRange[0] && _self.disabledRange[1]) {
              isDisabled = itemTime < starDate || itemTime > endDate;
            }
          }
          return isDisabled;
        },
      };
      // 快捷时间选择
      if (!_self.showShortcuts) {
      } else {
        pickerOption.shortcuts = [
          {
            text: "24小时",
            onClick(picker) {
              const start = _self.$moment()
                .subtract(1, "days")
                .format("YYYY-MM-DD HH:mm:ss");
              const end = _self.$moment().format("YYYY-MM-DD HH:mm:ss");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今天",
            onClick(picker) {
              const start = _self.$moment()
                .startOf("day")
                .format("YYYY-MM-DD HH:mm:ss");
              const end = _self.$moment().format("YYYY-MM-DD HH:mm:ss");
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const start = _self.$moment()
                .subtract(1, "days")
                .format("YYYY-MM-DD 00:00:00");
              const end = _self.$moment()
                .subtract(1, "days")
                .format("YYYY-MM-DD 23:59:59");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "三天",
            onClick(picker) {
              const start = _self.$moment()
                .subtract(2, "days")
                .startOf("day")
                .format("YYYY-MM-DD HH:mm:ss");
              const end = _self.$moment().format("YYYY-MM-DD HH:mm:ss");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "七天",
            onClick(picker) {
              const start = _self.$moment()
                .subtract(6, "days")
                .startOf("day")
                .format("YYYY-MM-DD HH:mm:ss");
              const end = _self.$moment().format("YYYY-MM-DD HH:mm:ss");
              picker.$emit("pick", [start, end]);
            },
          },
        ];
      }
      return pickerOption;
    },
  },
  methods: {
    // 选择时间回调
    changeDate(e) {
      if (e == null) e = [];
      this.$emit("change", e);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/components/DateRange.vue